import React, { useState, useEffect } from "react";
import { Accordion, AccordionItem } from "@appkit4/react-components/accordion";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import "datatables.net-dt/js/dataTables.dataTables";
import GeneralInformation from "../../vendorManagement/GeneralInformation";
import CoporateAddress from "../../vendorManagement/CoporateAddress";
import VendorInformation from "../../vendorManagement/VendorInformation";
import VendorContactInformation from "../../vendorManagement/VendorContactInformation";
import { Formik } from "formik";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import * as Yup from "yup";
import ConformationModal from '../../../Common/ConformationModal'
import AssessmentPlan from '../../Analyst/AssessmentPlan'
import InternalContacts from '../../vendorManagement/InternalContacts'
import Questionnaire from '../../vendorManagement/Questionnaire'
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";
import AddMoreSpocs from "../../vendorManagement/AddMoreSpocs";

export default function EditVendorRequest(props) {
    const { TPRequestData, View, questionnaireClassification } = props
    const [activeAccordions, setActiveAccordions] = useState(["0"])
    const [openedAccordions, setOpenedAccordions] = useState(false)
    const [modalVisible, setModalVisible] = useState(false);
    const [status, setStatus] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [subDepart, setSubDepart] = useState([]);
    const [requestedBy, setRequestedBy] = useState([]);
    const [manager, setManager] = useState([]);
    const [criticality, setCriticality] = useState([]);
    const [category, setCategory] = useState([]);
    const [classification, setClassification] = useState([]);
    const [assessor, setAssessor] = useState([]);
    const [assessmentTypes, setAssessmentTypes] = useState([])
    const [frequency, setFrequency] = useState([])
    const [recurrence, setRecurrence] = useState([])
    const [comments, setComments] = useState("");
    const [managerCommentsFlag, setManagerCommentsFlag] = useState(false)
    const [commentsFormat, setCommentsFormat] = useState(false)
    const [loader, setLoader] = useState(true);
    const [managerStatus, setManagerStatus] = useState("");
    const [thirdPartyUsers, setThirdPartyUsers] = useState([]);
    const [spocFlagEdit, setSpocFlagEdit] = useState(false);
    const [additionalSpocEdit, setAdditionalSpocEdit] = useState([]);
    const { sendRequest: getAllVendorList } = useHttp();
    const { sendRequest: getAllBusinessUnitList } = useHttp();
    const { sendRequest: getAllSubBusinessUnitList } = useHttp();
    const { sendRequest: getSelectedVendorAddress } = useHttp();
    const { sendRequest: getTPListDetails } = useHttp();
    const { sendRequest: getTPContactInfo } = useHttp();
    const { sendRequest: updatePlanRequest } = useHttp();
    const { sendRequest: getStatus } = useHttp();
    const { sendRequest: getAllBUUsersList } = useHttp();
    const { sendRequest: getCriticalityList } = useHttp();
    const { sendRequest: getCategoryList } = useHttp();
    const { sendRequest: getAllBUFrequencyList } = useHttp();
    const { sendRequest: getAllBUAssessmentTypeList } = useHttp();
    const { sendRequest: getAllBURecurrenceList } = useHttp();
    const { sendRequest: getAllManagersList } = useHttp();
    const { sendRequest: getAllAssessorsList } = useHttp();
    const { sendRequest: getAllClassifications } = useHttp();
    const { sendRequest: handleNotificationSubmitAPI } = useHttp();
    var mode = "add"

  useEffect(() => {
    getInitialDataHandler();
    if (TPRequestData[0].additionalSpoc?.length) {
      setSpocFlagEdit(true);
      const tempData = TPRequestData[0].additionalSpoc.map((item) => ({
              firstNameAdditional: item?.firstNameAdditional,
              lastNameAdditional: item?.lastNameAdditional,
              emailAdditional: item?.emailAdditional,
              phoneNumberAdditional: item?.phoneNumberAdditional,
              businessDesignationAdditional: item?.businessDesignationAdditional
      }))
      setAdditionalSpocEdit(prevState => 
        [
          ...prevState, ...tempData
        ]
      )
    }
    else {
      setSpocFlagEdit(false);
    }
  }, []);

  const spocDropdownData = [
    {
      value: true,
      label: 'Yes'
    },
    {
      value: false,
      label: 'No'
    }
  ] 

  const errorFunction = (errors, touched) => {
    let touchedArr = Object.keys(touched);

    if (touchedArr.length === 29) {
      let arr = [];
      let keys = Object.keys(errors);

      if (
        keys.includes("status") ||
        keys.includes("requestedBy") ||
        keys.includes("thirdPartyID") ||
        keys.includes("thirdPartyName") ||
        keys.includes("department") ||
        keys.includes("subDepartment") ||
        keys.includes("totalContractValue") ||
        keys.includes("countryOfBusiness")
      ) {
        arr.push("1");
      }

      if (
        keys.includes("address") ||
        keys.includes("country") ||
        keys.includes("city") ||
        keys.includes("state") ||
        keys.includes("zip") ||
        keys.includes("phonenumber")
      ) {
        arr.push("2");
      }

      if (
        keys.includes("criticality") ||
        keys.includes("category") ||
        keys.includes("others")
      ) {
        arr.push("3");
      }

      if (
        keys.includes("designation") ||
        keys.includes("firstName") ||
        keys.includes("lastName") ||
        keys.includes("vendorPhoneNumber") ||
        keys.includes("email")
      ) {
        arr.push("4");
      }

      if (
        keys.includes("assessment") ||
        keys.includes("frequency") ||
        keys.includes("recurrence") ||
        keys.includes("endAfter") ||
        keys.includes("regulatory")
      ) {
        arr.push("5");
      }
      // setActiveAccordions(arr)
    }
  };

  const responseHandler = (result) => {
    if (result.CODE) {
      let temp = [
        {
          vendor_id: 0,
          vendor_name: `<h6>Add New Third Party+</h6>`,
        },
      ];
      result.MSG.forEach((item) => {
        temp.push(item);
      });
      setVendors(temp);
    }
  };

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
  };

  const responseHandlerBU = (result) => {
    if (result.CODE) {
      setDepartments(result.MSG);
    }
  };

  const responseHandlerSBU = (result) => {
    if (result.CODE) {
      setSubDepart(result.MSG);
    }
  };

      const responseHandlerStatus = (result) => {
        if (result.CODE) {
          setStatus(result.MSG);
        } 
      }

      const responseHandlerBUUsers = (result) => {
        if (result.CODE) {
          setRequestedBy(result.MSG);
        }
      }

      const responseHandlerCriticality = (result) => {
        if (result.CODE) {
          setCriticality(result.MSG);
        }
      }

      const responseHandlerCategory = (result) => {
        if (result.CODE) {
          setCategory(result.MSG);
        }
      }

      const responseHandlerBUAssessmentType = (result) => {
        if (result.CODE) {
          setAssessmentTypes(result.MSG);
        }
      }

      const responseHandlerFrequency = (result) => {
        if (result.CODE) {
          setFrequency(result.MSG);
        }
      }

      const responseHandlerBURecurrence = (result) => {
        if (result.CODE) {
          setRecurrence(result.MSG);
        }
      }

      const responseHandlerManager = (result) => {
        if (result.CODE) {
          setManager(result.MSG);
        }
      }

      const responseHandlerAssessor = (result) => {
        if (result.CODE) {
          setAssessor(result.MSG);
        }
      }

      const responseHandlerClassifications = (result) => {
        if (result.CODE) {
          setClassification(result.MSG);
        }
      }

    let getInitialDataHandler = async () => {
        getAllVendorList(APIService.getAllVendorList(), responseHandler, errorHandler)
        getAllBusinessUnitList(APIService.getAllBusinessUnitList(), responseHandlerBU, errorHandler)
        getAllSubBusinessUnitList(APIService.getAllSubBusinessUnitList(), responseHandlerSBU, errorHandler)
        getStatus(APIService.getStatus(), responseHandlerStatus, errorHandler)
        getAllBUUsersList(APIService.getAllBUUsersList(), responseHandlerBUUsers, errorHandler)
        getCriticalityList(APIService.getCriticalityList(), responseHandlerCriticality, errorHandler)
        getCategoryList(APIService.getCategoryList(), responseHandlerCategory, errorHandler)
        getAllBUAssessmentTypeList(APIService.getAllBUAssessmentTypeList(), responseHandlerBUAssessmentType, errorHandler)
        getAllBUFrequencyList(APIService.getAllBUFrequencyList(), responseHandlerFrequency, errorHandler)
        getAllBURecurrenceList(APIService.getAllBURecurrenceList(), responseHandlerBURecurrence, errorHandler)
        getAllManagersList(APIService.getAllManagersList(), responseHandlerManager, errorHandler)
        getAllAssessorsList(APIService.getAllAssessorsList(), responseHandlerAssessor, errorHandler)
        getAllClassifications(APIService.getAllClassifications(), responseHandlerClassifications, errorHandler)
            setLoader(false);
    }

    const handleCancel = () => {
        setModalVisible(false);
    };
    const handleConfirm = (param) => {
        if (comments.trim().length>0  && !commentsFormat){
            setModalVisible(true);
            setManagerStatus(param);
            }
        else{
            setManagerCommentsFlag(true)
        }
    };
    const showModal = () => {
        setModalVisible(true);
    }

    const responseHandlerUpdatePlan = (result) => {
        if(result.CODE[0].addcomments){
            if(result.MSG === "Approved"){
                let notifData = {
                    paramuserid: Number(sessionStorage.getItem("userId")),
                    paramreqid: TPRequestData && TPRequestData[0].vendorAssessReqId,
                    paramcontent: "Approved Assessment Plan",
                    paramnextroleid: 3,
                    paramcreatedby: Number(sessionStorage.getItem("roleId")),
                    parammsgtype: result.MSG
                }
                handleNotificationSubmitAPI(
                  APIService.handleNotificationSubmit(notifData),
                  () => {}
                );
                displayToastMessage("Assessment plan approved successfully", "success")
                props.sendBack()
                setManagerCommentsFlag(false)
            }
            else if(result.MSG === "Rejected"){
                let notifData = {
                    paramuserid: Number(sessionStorage.getItem("userId")),
                    paramreqid: TPRequestData && TPRequestData[0].vendorAssessReqId,
                    paramcontent: "Rejected Assessment Plan",
                    paramnextroleid: 3,
                    paramcreatedby: Number(sessionStorage.getItem("roleId")),
                    parammsgtype: result.MSG
                }
                handleNotificationSubmitAPI(
                  APIService.handleNotificationSubmit(notifData),
                  () => {}
                );
                displayToastMessage("Assessment plan rejected successfully", "success")
                props.sendBack()
                setManagerCommentsFlag(false)
            }
        }
        else{
            let MSG = "Something went wrong, Please try again!"
            displayToastMessage(MSG, "error")
        }
    }

    const handleUpdate = async (values) => {
        let data = {
            paramvendorassessmentrequestid: TPRequestData[0]?.vendorAssessReqId,
            paramvendorassessmentplanid: 5,
            paramvendorid: TPRequestData[0]?.vendorId,
            paramcomments: comments,
            email: TPRequestData[0]?.vendorPointOfContactEmail,
            paramroleid: Number(sessionStorage.getItem("roleId")),
            paramuserid: Number(sessionStorage.getItem("userId")),
            paramstatus: managerStatus,
            paramFlag: "Plan Comments"
        }
        updatePlanRequest(APIService.updatePlanRequest(data), responseHandlerUpdatePlan, errorHandler)
        setModalVisible(true)
    }

  function formatDate(date) {
    let newDate = "";
    if (date && date !== null) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      newDate = [year, month, day].join("-");
    }
    return newDate;
  }

  //Formik Initial Values
  const getTPRKeyValue = (key) => {
    if (TPRequestData.length > 0) {
      return TPRequestData[0][key];
    }
    return "";
  };

  let GeneralInformationInitialValues = {
    status: getTPRKeyValue("statusId"),
    requestedBy: getTPRKeyValue("requestedBy"),
    thirdPartyID: getTPRKeyValue("vendorId"),
    department: getTPRKeyValue("vendorDepartId"),
    subDepartment: getTPRKeyValue("vendorSubDepartId"),
    totalContractValue: getTPRKeyValue("totalContractValue"),
    countryOfBusiness: getTPRKeyValue("countriesOfBusiness").split(","),
    boarding: getTPRKeyValue("BoardingType"),
  };
  let AssessmentPlanInitialValues = {
    vendorname: getTPRKeyValue("vendorId"),
    assessmentCriticality: getTPRKeyValue("criticality"),
    planFrequency: getTPRKeyValue("assessReqFrequency"),
    recurrenceMonth: getTPRKeyValue("assessReqRecurrenceMonths"),
    totalAssessment: getTPRKeyValue("totalAssessments"),
    completed: getTPRKeyValue("completed"),
    nextPlannedDate: formatDate(getTPRKeyValue("nextPlannedDate")),
    lastAssessmentDate: formatDate(getTPRKeyValue("lastAssessmentDate")),
    informationClassification: Number(
      TPRequestData && questionnaireClassification.response
    ),
    assessmentType: getTPRKeyValue("assessReqAssesmentType"),
    assessor: getTPRKeyValue("assessorId"),
    manager: getTPRKeyValue("managerId"),
  };
  let CoporateAddressInitialValues = {
    address: getTPRKeyValue("address"),
    country: getTPRKeyValue("country"),
    city: getTPRKeyValue("city"),
    state: getTPRKeyValue("state"),
    zip: getTPRKeyValue("zip"),
    phonenumber: getTPRKeyValue("phoneNumber"),
  };

  let VendorInformationInitialValues = {
    criticality: getTPRKeyValue("criticality"),
    category: getTPRKeyValue("category"),
    others: getTPRKeyValue("categoryOthers"),
  };

  let vendorContactInformationInitialValues = {
    designation: getTPRKeyValue("vendorPointOfContactBusinessDesignation"),
    firstName: getTPRKeyValue("vendorPointOfContactFirstName"),
    lastName: getTPRKeyValue("vendorPointOfContactLastName"),
    vendorPhoneNumber: getTPRKeyValue("vendorPointOfContactPhone"),
    email: getTPRKeyValue("vendorPointOfContactEmail"),
  };

  let assessmentInitialValues = {
    assessment: getTPRKeyValue("assessReqAssesmentType"),
    frequency: getTPRKeyValue("assessReqFrequency"),
    recurrence: getTPRKeyValue("assessReqRecurrenceMonths"),
    endAfter: getTPRKeyValue("assessReqEndAfter"),
    regulatory: getTPRKeyValue("assessReqRegulatoryStandardRequirements"),
  };

  let InternalContactsInitialValues = {
    InternalContacts:
      TPRequestData && TPRequestData[0].jsonInternalContactDetails
        ? TPRequestData && TPRequestData[0].jsonInternalContactDetails
        : [],
  };

  let QuestionnaireInitialValues = {
    questions:
      TPRequestData && TPRequestData[0].jsonVendorQuestionnaireMaster
        ? TPRequestData && TPRequestData[0].jsonVendorQuestionnaireMaster
        : [],
  };

  //Formik Validation Schemas
  const validationSchema = Yup.object().shape({
    status: Yup.string()
      .required("Status is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    requestedBy: Yup.string()
      .required("Requested by is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    thirdPartyID: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    department: Yup.string()
      .required("Department is Required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    subDepartment: Yup.string()
      .required("Sub - Department is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    countryOfBusiness: Yup.array()
      .min(1)
      .required("Country of Business is required"),
    totalContractValue: Yup.number().required(
      "Total Contract value is required"
    ),

    address: Yup.string()
      .required("Address is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    country: Yup.string()
      .required("Please select country")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    city: Yup.string()
      .required("City is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    state: Yup.string()
      .required("State is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    zip: Yup.string()
      .required("Zip is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    phonenumber: Yup.number().required("Phone number is required"),

    criticality: Yup.string()
      .required("Criticality is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    category: Yup.string()
      .required("Category is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),

    firstName: Yup.string()
      .required("First name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    lastName: Yup.string()
      .required("Last name is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    designation: Yup.string()
      .required("Business designation is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    vendorPhoneNumber: Yup.number().required("Phone number is required"),
    email: Yup.string().email().required("Email Id is required"),

    vendorname: Yup.string()
      .required(" Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    assessmentCriticality: Yup.string()
      .required("Criticality is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    assessmentType: Yup.string()
      .required("Please select assessment")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
   
    totalAssessment: Yup.number().required("Total assessment is required"),
    completed: Yup.number().required("Completed is required"),
    recurrenceMonth: Yup.string()
      .required("Please select recurrence")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    nextPlannedDate: Yup.string().required("Next Planned date is required"),
    informationClassification: Yup.string()
      .required("Information classification is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    assessor: Yup.string()
      .required("Assessor is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    manager: Yup.string()
      .required("Manager is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),

    InternalContacts: Yup.array().of(
      Yup.object().shape({
        username: Yup.string().required("User Name is required"),
        department: Yup.string().required("Department is required"),
        roleInProject: Yup.string()
          .required("Role is required")
          .matches(
            /^[a-zA-Z\d\-_.,&#()\s]+$/,
            "Only alphabets, numbers and some special characters are allowed for this field "
          ),
      })
    ),

    questions: Yup.array().of(
      Yup.object().shape({
        response: Yup.string()
          .nullable()
          .required("Response is required")
          .matches(
            /^[a-zA-Z\d\-_.,&#()\s]+$/,
            "Only alphabets, numbers and some special characters are allowed for this field "
          ),
      })
    ),
  });

  const InitialValues = {
    ...AssessmentPlanInitialValues,
    ...GeneralInformationInitialValues,
    ...CoporateAddressInitialValues,
    ...VendorInformationInitialValues,
    ...vendorContactInformationInitialValues,
    ...assessmentInitialValues,
    ...InternalContactsInitialValues,
    ...QuestionnaireInitialValues,
  };

  const handleAccordions = (e) => {
    setActiveAccordions(e);
  };
  const handleReset = () => {
    setActiveAccordions([]);
  };

  const handleSubmit = async (values, { errors }) => {};

  const expandAllAccordions = () => {
    if (!openedAccordions) {
      setActiveAccordions(["0", "1", "2", "3", "4", "5", "6"]);
    } else {
      setActiveAccordions([]);
    }
    setOpenedAccordions((prev) => !prev);
  };

  const handleChangeComment = (e) => {
    if (e.target.value.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e.target.value);
  };

  return (
    <div className="App">
      {loader ? (
        <div className="row" id="preloader">
          <div className="col-12 col-lg-12 loader-margin text-center">
            <div className="a-loading a-primary a-m-10" >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="row text-right pt-2">
            <div className="col-md-12">
              <span
                className="pr-2 color-e0 underline l-h-1-9 pointer"
                onClick={expandAllAccordions}
              >
                {!openedAccordions ? "Expand All" : "Collapse All"}
              </span>
              <span
                className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
                onClick={props.sendBack}
              ></span>
            </div>
          </div>

          <div className="pt-3">
            <Formik
              initialValues={InitialValues}
              onReset={handleReset}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              {(prop) => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  handleReset,
                  isSubmitting,
                } = prop;

                errorFunction(errors, touched);
                const getTPContactDetails = async (e) => {
                  if (e !== 0) {
                    getTPContactInfo(
                      APIService.getTPContactInfo(e),
                      (result) => {
                        if (result.CODE) {
                          const data = result.MSG[0];
                          Object.keys(data).map((key) => {
                            handleChange(key)({ target: { value: data[key] } });
                          });
                        }
                      }
                    );
                  } else {
                    handleChange("lastName")({ target: { value: "" } });
                    handleChange("email")({ target: { value: "" } });
                    handleChange("vendorPhoneNumber")({
                      target: { value: "" },
                    });
                    handleChange("designation")({ target: { value: "" } });
                  }
                };
                const vendorAddress = async (e) => {
                  if (e !== 0) {
                    getTPListDetails(
                      APIService.getTPListDetails(e),
                      (result) => {
                        if (result.CODE) {
                          let temp = [
                            {
                              user_id: 0,
                              user_name: `<h6>Add New Third Party User +</h6>`,
                            },
                          ];
                          result.MSG.forEach((item) => {
                            temp.push(item);
                          });
                          setThirdPartyUsers(temp);
                        }
                      }
                    );
                    getSelectedVendorAddress(
                      APIService.getSelectedVendorAddress({ vendorID: e }),
                      (result) => {
                        if (result.CODE) {
                          const data = result.MSG[0];
                          Object.keys(data).map((key) => {
                            handleChange(key)({ target: { value: data[key] } });
                          });
                        }
                      },
                      errorHandler
                    );
                  } else {
                    handleChange("address")({ target: { value: "" } });
                    handleChange("country")({ target: { value: "" } });
                    handleChange("city")({ target: { value: "" } });
                    handleChange("state")({ target: { value: "" } });
                    handleChange("zip")({ target: { value: "" } });
                    handleChange("phonenumber")({ target: { value: "" } });
                    handleChange("requestedBy")({
                      target: {
                        value: Number(sessionStorage.getItem("userId")),
                      },
                    });
                    handleChange("department")({ target: { value: "" } });
                    handleChange("subDepartment")({ target: { value: "" } });
                  }
                };

                return (
                  <form onSubmit={handleSubmit}>
                  {spocFlagEdit ? (
                    <Accordion
                    kind="transparent"
                    onClick={handleAccordions}
                    activeKeys={activeAccordions}
                  >
                    <AccordionItem itemKey="0" title="Assessment Plan">
                      <AssessmentPlan
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        assessmentTypes={assessmentTypes}
                        frequency={frequency}
                        vendors={vendors}
                        Assessors={assessor}
                        Managers={manager}
                        Classification={classification}
                        recurrence={recurrence}
                        criticality={criticality}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="1" title="General Information">
                      <GeneralInformation
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        status={status}
                        vendors={vendors}
                        departments={departments}
                        subDepart={subDepart}
                        requestedBy={requestedBy}
                        vendorAddressHandler={vendorAddress}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="2" title="Corporate Address">
                      <CoporateAddress
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem
                      itemKey="3"
                      title="Third Party Information"
                    >
                      <VendorInformation
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        criticality={criticality}
                        category={category}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem
                      itemKey="4"
                      title="Third Party Point of Contact Information"
                    >
                      <VendorContactInformation
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        role={"manager"}
                        dropdownFlag={spocFlagEdit}
                        spocDropdownData={spocDropdownData}
                        editScreen={true}
                      />
                    </AccordionItem>
                    <AccordionItem
                        itemKey="5"
                        title="Additional Point of Contact Information"
                        >
                          <AddMoreSpocs 
                            role={"manager"}
                            additionalSpoc={additionalSpocEdit}
                            editScreen={true}
                          /> 
                        </AccordionItem>
                    <AccordionItem itemKey="6" title="Internal Contacts">
                      <InternalContacts
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        mode={mode}
                        departments={departments}
                        requestedBy={requestedBy}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="7" title="Questionnaire">
                      <Questionnaire
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        role={"manager"}
                      />
                    </AccordionItem>
                  </Accordion>
                  ) : (
                    <Accordion
                    kind="transparent"
                    onClick={handleAccordions}
                    activeKeys={activeAccordions}
                  >
                    <AccordionItem itemKey="0" title="Assessment Plan">
                      <AssessmentPlan
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        assessmentTypes={assessmentTypes}
                        frequency={frequency}
                        vendors={vendors}
                        Assessors={assessor}
                        Managers={manager}
                        Classification={classification}
                        recurrence={recurrence}
                        criticality={criticality}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="1" title="General Information">
                      <GeneralInformation
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        status={status}
                        vendors={vendors}
                        departments={departments}
                        subDepart={subDepart}
                        requestedBy={requestedBy}
                        vendorAddressHandler={vendorAddress}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="2" title="Corporate Address">
                      <CoporateAddress
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem
                      itemKey="3"
                      title="Third Party Information"
                    >
                      <VendorInformation
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        criticality={criticality}
                        category={category}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem
                      itemKey="4"
                      title="Third Party Point of Contact Information"
                    >
                      <VendorContactInformation
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        role={"manager"}
                        dropdownFlag={spocFlagEdit}
                        spocDropdownData={spocDropdownData}
                        editScreen={true}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="5" title="Internal Contacts">
                      <InternalContacts
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        mode={mode}
                        departments={departments}
                        requestedBy={requestedBy}
                        role={"manager"}
                      />
                    </AccordionItem>
                    <AccordionItem itemKey="6" title="Questionnaire">
                      <Questionnaire
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        role={"manager"}
                      />
                    </AccordionItem>
                  </Accordion>
                  )}
                    <div className="row m-0">
                      <div className="col-sm-6">
                        <div className="cv-input-field-container">
                          <label className="cv-input-label">
                            Manager Comments
                            <span className="asterisk-required">*</span>
                          </label>
                          <input
                            className="cv-input-field"
                            type="text"
                            value={comments}
                            onChange={handleChangeComment}
                            name="comments"
                            placeholder="Add your comments."
                          />
                        </div>
                        {comments === "" && managerCommentsFlag && (
                          <label className="requiredComments">
                            Please enter comments
                          </label>
                        )}
                        {commentsFormat && (
                          <label className="requiredComments">
                            Only alphabets and some special characters are
                            allowed for this field
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="options-container">
                      {View && View && (
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="save-button "
                          onClick={() => handleConfirm("Approved")}
                        >
                          Approve
                        </button>
                      )}
                      {View && View && (
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="save-button m-l-2"
                          onClick={() => handleConfirm("Rejected")}
                        >
                          Reject
                        </button>
                      )}
                      <button
                        className="cancel-button m-l-2"
                        type="reset"
                        onClick={props.sendBack}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      )}
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          Are you sure you want to Process the Request?
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
            </button>

            <button
              type="submit"
              className="save-button m-l-2 removeRadius"
              onClick={handleUpdate}
            >
              Yes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}
